<template>
  <b-row style="position:relative">
    <b-col cols="12" ref="u">
      <div class="filters-container">
        <DropdownColumns v-model="fields" class="customize" />
      </div>
      <b-table
        id="users-table"
        :busy.sync="isBusy"
        show-empty
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :hover="true"
        :striped="true"
        stacked="md"
        :items="provider"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        tbody-tr-class="tr-pointer"
        @row-clicked="rowClicked"
      >
        <template v-slot:empty="scope">
          <div class="text-center">{{ $t(scope.emptyText) }}</div>
        </template>

        <template v-slot:head(username)="data">{{ $t(data.label) }}</template>
        <template v-slot:head(name)="data">{{ $t(data.label) }}</template>
        <template v-slot:head(surname)="data">{{ $t(data.label) }}</template>
        <template v-slot:head(epermission_role_ids)="data">{{ $t(data.label) }}</template>
        <template v-slot:head(discrete_permissions)="data">{{ $t(data.label) }}</template>

        <template v-slot:cell(epermission_role_ids)="data">
          [
          <span v-for="(item, index) in data.value" :key="index">
            <span v-if="item.to">
              <router-link :to="`/roles/${item.to}`">{{ item.name }}</router-link>
            </span>
            <span v-else>{{ item.name }}</span>
            <span v-if="index < data.value.length-1">,</span>
          </span>
          ]
        </template>
      </b-table>
      <div class="container-fluid">
        <div class="row">
          <div style="white-space:nowrap;" class="my-2">
            <PaginationSelect
              v-model="perPage"
              :options="paginationOpts"
              variant="brand"
              size="sm"
            />
            <span>
              &nbsp;
              <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                <span slot="start">{{(currentPage-1) * perPage + 1}}</span>
                <span slot="end">{{currentPage * perPage}}</span>
                <span slot="total">{{totalRows}}</span>
              </i18n>
            </span>
            <b-button
              size="sm"
              @click.stop="$root.$emit('bv::refresh::table', 'users-table')"
              class="ml-2 refresh"
              variant="light"
              :title="$t('Refresh')"
            >
              <i class="icon-refresh"></i>
            </b-button>
          </div>
          <nav class="ml-auto mt-2">
            <b-pagination
              size="md"
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
            />
          </nav>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import startCase from "@/shared/strings";
import { errorConf, successConf } from "@/shared/notifications";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import FloatingLabel from "@/components/FloatingLabel";

export default {
  components: {
    PaginationSelect,
    DropdownColumns,
    FloatingLabel
  },
  name: "usersShop",
  props: ["eshop_id", "shop_name"],
  data: function() {
    return {
      tableName: "usersShop",
      isBusy: false,
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "eid",
          label: "Id",
          sortable: false,
          class: "d-none",
          ignore: true
        },
        { key: "username", sortable: true, class: "" },
        { key: "name", sortable: true, class: "" },
        { key: "surname", sortable: true, class: "" },
        {
          key: "epermission_role_ids",
          label: "Roles",
          sortable: true,
          class: "",
          ignore: true
        },
        {
          key: "discrete_permissions",
          sortable: true,
          class: "",
          ignore: true
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,

      filter: null,
      filterField: null,

      details: {
        eid: null,
        eshop_id: null,
        tax: null,
        app_id: null,
        install_code: null
      },

      addMode: true
    };
  },
  computed: {
    paginationOpts() {
      return [
        { value: 5 },
        { value: 10 },
        { value: 15 },
        { value: 25 },
        { value: 50 }
      ];
    }
  },
  created() {
    if (this.eshop_id != "0" && this.eshop_id != "") {
      this.$root.$emit("bv::refresh::table", "users-table");
    }
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "users-table");
    },
    provider(ctx, callback) {
      if (!this.eshop_id) {
        callback([]);
        return;
      }

      const loading = this.$loading.open({
        container: this.$refs.u
      });

      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage,
        exactFields: ["shop_ids"],
        exactValues: [[this.eshop_id]],
        fields: [
          "id",
          "username",
          "name",
          "surname",
          "discrete_permissions",
          "permission_role_ids"
        ]
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        paginationData.sortBy = [this.sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const roleByID = this.$store.getters["cache/roleByID"];

      Promise.all([
        this.$store.dispatch("cache/fetch", "roles").catch(e => e)
      ]).finally(() => {
        this.$store
          .dispatch("user/fetch", paginationData)
          .then(resp => {
            this.totalRows = resp.data.total;

            resp.data.rows.forEach((item, index) => {
              if (item.epermission_role_ids) {
                const tmp = [];
                for (let i = 0; i < item.epermission_role_ids.length; i += 1) {
                  const rid = item.epermission_role_ids[i];
                  const data = roleByID(rid);
                  if (data) {
                    tmp.push({ to: rid, name: data.name });
                  } else {
                    tmp.push({ to: null, name: rid });
                  }
                }
                item.epermission_role_ids = tmp;
              }
            });

            callback(resp.data.rows);
          })
          .catch(err => {
            this.$bvToast.toast(
              this.$t(err.message),
              errorConf(this.$t("Error"))
            );
            this.totalRows = 0;
            callback([]);
          })
          .finally(() => {
            loading.close();
          });
      });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    rowClicked(item, index, event) {
      this.$router.push("/users/" + item.eid);
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


